import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
const Tab1 = ({ ischeckboxEnabled, Whole_Number, UOMName }) => {

  return (
     <div>
          <div className="px-4 py-4" style={{ background: 'white' }}>
    
            <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >
    
              <div className="col-md-12">
                <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
    
                  <div style={{ display: 'flex', gap: '15px', marginBottom: '-10px' }}>
                <div style={{ flex: 1 }}>
                  <p className='' style={{ fontSize: '16px', fontWeight: '600', marginLeft: '2px' }}>Details</p>
                </div>
              </div>
                  <div style={{ display: 'flex', gap: '15px' }}>
                    <div style={{ flex: 1 }}>
                      <label style={{height: '19px'}}></label>
                     <Checkbox
              className={ischeckboxEnabled.Error ? `errorborder` : ``}
                id="ischeckboxEnabled"
                checked={ischeckboxEnabled}
                label="Enabled"
                value={ischeckboxEnabled?.ischeckboxEnabled || false}
                onChange={(val) => ischeckboxEnabled?.setischeckboxEnabled?.(val)}
                disabled
                
              />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{height: '19px'}}></label>
                     <Checkbox
                id="Whole_Number"
                label="Must be Whole Number"
                value={Whole_Number?.Whole_Number || false}
                onChange={(val) => Whole_Number?.setWhole_Number?.(val)}
                disabled
              />
    
                    </div>
                    <div style={{ flex: 1 }}>
                       <Input
                id="UOMName"
                label="UOM Name"
                style={{ height: "30px", border: UOMName.Error ? "1px solid red" : "", }}
                value={UOMName.UOMName}
                onChange={(e) => UOMName.setUOMName(e.target.value)}
                readOnly
              />
                    </div>
                    <div style={{ flex: 1 }}>
                       
                    </div>
                  </div>
    
    
    
    
    
    
    
                </div>
              </div>
    
            </div>
      <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >
    
              <div className="col-md-12">
                <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
    
             <ActivityCard doctype="UOM" docname={UOMName.UOMName} />
    </div>
    </div>
    </div>
          </div>
        </div>

  )
}

export default Tab1